import React from 'react'
import {
    Button,
    AppBar,
    Toolbar,
    Link,
    Box,
    InputAdornment
} from '@mui/material'
import FileUploadIcon from '@mui/icons-material/FileUpload';
import SearchIcon from '@mui/icons-material/Search';
import { CustomTextField } from './CustomeTextField';

const Navbar = ({ Upload, Filter, SearchField }) => {
  return (
    <AppBar position='static' sx={{ backgroundColor: "#202020" }}>
        <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
                <Link href='/'>
                    <img src="logo.png" alt="" />
                </Link>
            </Box>
            <Box style={{flexGrow: 1}}>
                {SearchField}
            </Box>
            <Box>
                {Upload}
            </Box>
        </Toolbar>
        {Filter}
    </AppBar>
  )
}

export default Navbar